// Parallax Effect
const bannerItems = document.querySelectorAll(".hero-banner-container");

// Only initialize parallax if banner items exist
if (bannerItems.length > 0) {
  const scrollFactor = 0.25; // Adjust this between 0 (fixed) and 1 (normal scrolling)

  const updateImagePosition = () => {
    const offset = window.scrollY * scrollFactor;
    bannerItems.forEach((item) => {
      const img = item.querySelector("img"); // Find the <img> tag inside the banner item
      if (img) {
        // Apply a translation to the image to simulate the parallax effect
        img.style.transform = `translateY(${offset}px)`;
      }
    });
  };

  // Set initial image position
  updateImagePosition();

  // Update image position on scroll
  window.addEventListener("scroll", updateImagePosition);
}
